var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-call 1",
    clipPath: "url(#clip0_51_6905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6411 12.6445L13.1703 10.1734C12.6782 9.68322 11.8631 9.69823 11.3537 10.2076L10.109 11.4523C10.0304 11.4088 9.94898 11.3635 9.86337 11.3155C9.07731 10.88 8.00134 10.283 6.86905 9.1499C5.73361 8.01453 5.13584 6.93682 4.6991 6.15021C4.65274 6.06681 4.60867 5.98657 4.56515 5.91028L5.40064 5.0759L5.81132 4.66467C6.32151 4.15448 6.33565 3.3396 5.84441 2.84813L3.37348 0.376639C2.88256 -0.114279 2.06713 -0.099352 1.55694 0.410836L0.860524 1.1112L0.879715 1.13015C0.64626 1.42805 0.450952 1.77176 0.305951 2.14232C0.172007 2.49502 0.0886075 2.8317 0.0504619 3.16885C-0.275711 5.8738 0.960271 8.34576 4.31472 11.7005C8.9515 16.337 12.6884 15.9868 12.8495 15.9696C13.2008 15.9277 13.5371 15.8438 13.8792 15.7109C14.2466 15.5674 14.59 15.3726 14.8876 15.1397L14.9029 15.153L15.6084 14.4622C16.1174 13.9521 16.1321 13.1372 15.6411 12.6445ZM15.0595 13.9128L14.7485 14.2232L14.6247 14.3422C14.4297 14.5307 14.0922 14.7955 13.5993 14.9883C13.3195 15.096 13.0436 15.1652 12.7629 15.1986C12.7276 15.202 9.21292 15.5019 4.86297 11.1523C1.16435 7.4538 0.571628 5.32262 0.820088 3.25849C0.851204 2.98492 0.919835 2.7096 1.02953 2.42189C1.22397 1.92616 1.48854 1.58893 1.67564 1.39362L2.10551 0.959485C2.31266 0.751777 2.63576 0.735903 2.82514 0.925288L5.296 3.39615C5.48507 3.58577 5.47014 3.90886 5.26267 4.1172L3.59398 5.78424L3.74798 6.04344C3.83359 6.18788 3.9241 6.34979 4.02077 6.52567C4.47978 7.3535 5.1078 8.48665 6.32064 9.69839C7.53032 10.9087 8.66182 11.5362 9.48712 11.994C9.66545 12.0926 9.8283 12.1834 9.97441 12.2704L10.2342 12.4244L11.9017 10.7563C12.1098 10.5491 12.434 10.5338 12.6234 10.7226L15.0931 13.1929C15.2819 13.3822 15.2669 13.7053 15.0595 13.9128Z",
    fill: "#010002"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_6905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.45994627e90ee69ef318826197b8a9b2.svg";
export { ForwardRef as ReactComponent };